import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';

import CField from 'rise-ui/components/c-field.gjs';
import join from 'rise-ui/helpers/join.js';
import or from 'rise-ui/helpers/or.js';
import string from 'rise-ui/helpers/string.js';

export default class CatalogDetailDetailComponent extends Component {
  <template>
    <div class="id-catalog-record__fields qa-record-fields">
      <CField
        @label={{string "record-generation-effort-label"}}
        class="id-catalog-record__field--generation-effort"
        title={{or @record.generationEffort (string "record-generation-effort-empty")}}
        @value={{@record.generationEffort}}
      />
      <CField
        @label={{string "location-indirect-label"}}
        class="id-catalog-record__field--record-location-label"
        title={{@record.location.name}}
      >
        <LinksTo
          @route="location-detail"
          @model={{@record.location.id}} class="qa-location-link"
        >
          {{@record.location.name}}
        </LinksTo>
      </CField>
      {{#let (join @record.themes) as | recordThemes |}}
      <CField
        @label={{string "record-themes-label"}}
        class="id-catalog-record__field--themes"
        title={{or recordThemes (string "record-themes-empty")}}
        @value={{recordThemes}}
      />
      {{/let}}
      {{#let (join @record.tags) as | recordTags |}}
      <CField
        @label={{string "record-tags-label"}}
        class="id-catalog-record__field--tags"
        title={{or recordTags "No Tags"}}
        @value={{recordTags}}
      />
      {{/let}}
      {{#let (join @record.location.projectNames) as | projectNames |}}
      <CField
        @label={{string "record-project-label"}}
        class="id-catalog-record__field--bor-project"
        title={{or projectNames "No Projects"}}
        @value={{projectNames}}
      />
      {{/let}}
      {{#let (join @record.programNames) as | programNames |}}
      <CField
        @label={{string "record-program-label"}}
        class="id-catalog-record__field--bor-program"
        title={{or programNames "No Programs"}}
        @value={{programNames}}
      />
      {{/let}}
    </div>
  </template>
}
